import { Action } from '@ngrx/store';
import * as models from '../../domain/models';

export const LOAD = '[RM User Types] Load';
export const LOAD_SUCCESS = '[RM User Types] Load Success';
export const LOAD_FAIL = '[RM User Types] Load Fail';

export class LoadAction implements Action {
  readonly type = LOAD;
}

export class LoadSuccessPayload {
  entities: Array<models.UserType>;
}

export class LoadSuccessAction implements Action {
  readonly type = LOAD_SUCCESS;
  constructor(public payload: LoadSuccessPayload) {}
}

export class LoadFailAction implements Action {
  readonly type = LOAD_FAIL;
}

export type Actions = LoadAction | LoadSuccessAction | LoadFailAction;
